import React from 'react'
import SlopeInput from './SlopeInput'
import SlopeGraf from './SlopeGraf'
import styles from './s.module.css'

const Slope = ({slope, scale, dnIndex, fill, onInputChange, onGrafChange}) => {
  return (
    <div className={styles.dimItemContainer}>
      <label>hydraulický sklon [‰]</label>
      <SlopeInput value={slope} onChange={onInputChange} />
      <SlopeGraf scale={scale} slope={slope} dnIndex={dnIndex} filling={Math.min(1.001, fill * 0.01)}
        onChange={onGrafChange} />
    </div>
  )
}

// Slope.propTypes = {
//   slope: PropTypes.number,
//   scale: PropTypes.number,
//   dnIndex: PropTypes.number,
//   fill: PropTypes.number,
//   onInputChange: PropTypes.func,
//   onGrafChange: PropTypes.func
// }

export default Slope
